import React, {useRef} from 'react';
import {useTranslation} from "react-i18next";
import useOnClickOutside from "../Utils/use-onclick-outside";


const SubaccountDropdown = (props) => {
    const {t, i18n} = useTranslation();
    let subs = props.subAccounts;

    const ref = useRef();

    useOnClickOutside(ref, () => {
        if (document.getElementsByClassName('subaccount-dropdown--open').length > 0) {
            document.querySelector('.subaccount-dropdown').classList.remove('subaccount-dropdown--open');
        }
    });

    const showList = (event) => {
        event.currentTarget.classList.toggle("subaccount-dropdown--open")
    }

    if (subs === null) {
        return ''
    }
    let onlySubAccountCodeForInvoices = props.allInvoicesGrouped.map(item=>item.subAccountCode);
    subs = [...subs].filter((item)=>onlySubAccountCodeForInvoices.includes(item.subAccountCode));

    let label = "";

    if(props.current.length !== 0){
        //let item = subs.filter(i=> i.subAccountCode === props.current);
        label = <span className='selectedsub'>{
            props.current.length > 2 ? <React.Fragment>
                { props.current.length === subs.length ? t("payment.btn.allaccounts") : `${ props.current.length} ${t("payment.btn.selected")}` }
            </React.Fragment> : <React.Fragment>
                {props.current.map((item,i)=>{
                return  props.current.length - 1 !== i ? item + ', ' : item
                 })}
            </React.Fragment>


        }</span>;
    }else{
        label =  <React.Fragment>
            {t("payment.btn.selectanaccount")}
        </React.Fragment>
    }
    return (
        <div className="subaccount-dropdown" onClick={(event) => showList(event)} ref={ref}>
            <label className="subaccount-dropdown__label">
                {label}&nbsp;&nbsp;<i className="fas fa-angle-down"></i>
            </label>
            <div className="subaccount-dropdown__list">
                <ul>
                    <li>
                        <label className="checkbox-field checkbox-field--gray" htmlFor={`checkbox_all`} >
                            <input type="checkbox" name={`checkbox_all`} id={`checkbox_all`} className={'checkbox_all'}
                                   checked={
                                       props.current.length === subs.length
                                   }
                                   onChange={ ()=> {
                                       if(props.current.length === subs.length){ props.actionClick([])
                                       }else{ props.actionClick(subs.map((item)=> { return item.subAccountCode}))}}}/>
                            <span></span>
                            <div className="checkbox-field__text"><strong>{t("payment.btn.allaccounts")}</strong></div>
                        </label>

                    </li>
                    {
                    subs.map((item, i) => {
                        return <li key={i} data-value={item.subAccountCode} className={props.current === item.subAccountCode ? 'selected' : '' }>
                            <label className="checkbox-field checkbox-field--gray" htmlFor={`checkbox_${item.subAccountCode}`} >
                                <input type="checkbox" name={`checkbox_${item.subAccountCode}`} id={`checkbox_${item.subAccountCode}`}
                                       checked={props.current !== null ? props.current.includes(item.subAccountCode) : false}
                                       onChange={(e) => props.actionClick(item.subAccountCode)}/>
                                <span></span>
                                <div className="checkbox-field__text"><strong>{item.subAccountCode}</strong> <br/> <span>{item.subAccountName}</span></div>
                            </label>
                        </li>
                    })
                }
                </ul>
            </div>
        </div>
    )

}

export default SubaccountDropdown;
